import React, { useEffect, useReducer } from 'react'
import { inventoryColumns } from '../utils'
import { HttpClient } from '../../api/httpClient'

const initialState = {
    loading: false,
    records: [],
    currentPage: 1,
    limit: 10,
    totalPages: 0,
    filters: {},
    sort: {createdDate:'desc'},
    activeRecord: null
}

const TABLE = {
    UPDATE_LOADER: 'UPDATE_LOADER',
    INIT_RECORDS: 'INIT_RECORDS',
    UPDATE_RECORDS: 'UPDATE_RECORDS',
    PREV_PAGE: 'PREV_PAGE',
    NEXT_PAGE: 'NEXT_PAGE',
    UPDATE_PAGE: 'UPDATE_PAGE',
    UPDATE_TOTAL_PAGES: 'UPDATE_TOTAL_PAGES',
    UPDATE_FILTER: 'UPDATE_FILTER',
    UPDATE_SORT: 'UPDATE_SORT',
    UPDATE_ACTIVE_RECORD: 'UPDATE_ACTIVE_RECORD'
}

const reducerInventory = (state = initialState, action) => {

    switch (action.type) {
        case TABLE.UPDATE_LOADER:
            return {
                ...state,
                loading: action.payload
            }
        case TABLE.INIT_RECORDS:
            return {
                ...state,
                loading: false,
                records: action.payload.records,
                totalPages: action.payload.totalPages
            }
        case TABLE.UPDATE_RECORDS:
            return {
                ...state,
                records: action.payload
            }
        case TABLE.UPDATE_PAGE:
            return {
                ...state,
                activeRecord: null,
                currentPage: action.payload
            }
        case TABLE.PREV_PAGE:
            return {
                ...state,
                activeRecord: null,
                currentPage: state.currentPage - 1,
            }
        case TABLE.NEXT_PAGE:
            return {
                ...state,
                activeRecord: null,
                currentPage: state.currentPage + 1
            }
        case TABLE.UPDATE_TOTAL_PAGES:
            return {
                ...state,
                totalPages: action.payload
            }

        case TABLE.UPDATE_FILTER:
            return {
                ...state,
                activeRecord: null,
                filters: {
                    ...state.filters,
                    [action.payload.name]: action.payload.value
                }
            }
        case TABLE.UPDATE_SORT:
            return {
                ...state,
                sort: action.payload
            }
        case TABLE.UPDATE_ACTIVE_RECORD:
            return {
                ...state,
                activeRecord: action.payload
            }

        default:
            return state

    }

}

const useInventory = () => {

    const [state, dispatch] = useReducer(reducerInventory, initialState)

    const onPageChange = (page) => {
        dispatch({ type: TABLE.UPDATE_PAGE, payload: page })
    }

    const onPrevPage = () => {
        dispatch({ type: TABLE.PREV_PAGE })
    }

    const onNextPage = () => {
        dispatch({ type: TABLE.NEXT_PAGE })
    }

    const onFilter = (params) => {
        const { name, value } = params
        dispatch({ type: TABLE.UPDATE_FILTER, payload: { name, value } })
    }
    const onSort = (params) => {
        const { name = '', value = '' } = params
        dispatch({ type: TABLE.UPDATE_SORT, payload: (name && value) ? { [name]: value } : {} })
    }

    const onActiveRecord = (record) => {
        dispatch({ type: TABLE.UPDATE_ACTIVE_RECORD, payload: record })
    }

    const getInventoryList = async () => {
        try {
            dispatch({ type: TABLE.UPDATE_LOADER, payload: true })
            const data = {
                eventMessage: {
                    offset: String((state.currentPage - 1) * state.limit),
                    limit: state.limit,
                    filter: state?.filters,
                    sort: state.sort
                },
                eventType: "GET_CCS_DATA",
                eventTime: Date.now()
            }
            const response = await HttpClient.post(data)

            const { ccsList = [], totalRecordsCount = 0 } = response?.data?.eventMessage ?? {}

            dispatch({ type: TABLE.INIT_RECORDS, payload: { records: ccsList, totalPages: Math.ceil(totalRecordsCount / state.limit) } })

        } catch (err) {
            console.log(err)
        } finally {
            dispatch({ type: TABLE.UPDATE_LOADER, payload: false })
        }
    }

    useEffect(() => {
        getInventoryList()
    }, [state.sort, state.filters, state.currentPage])

    return {
        loading: state.loading,
        activeRecord: state.activeRecord,
        columns: inventoryColumns,
        records: state.records,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        sort: state.sort,
        onPageChange,
        onPrevPage,
        onNextPage,
        onFilter,
        onSort,
        onActiveRecord
    }
}

export default useInventory